export default __webpack_public_path__ + "static/allency-support-areas-design-7004576beac972cf678fbaf8159ebcd0.svg";